import React from "react";

export default function CandidateSkills({ candidate }) {
  const { interpersonalCharacteristics, technicalSkills } = candidate;

  return (
    <div className="py-5">
      <div className="py-4 px-2">
        <h2 className="font-bold text-xl mb-4">Interpersonal Skills</h2>

        <div className="flex">
          {interpersonalCharacteristics.map((skill) => (
            <div
              className="py-2 mr-2 px-4 text-xs leading-3 text-white rounded-full bg-blue-700 hover:bg-blue-800 cursor-pointer shadow-md"
              key={skill}
            >
              {skill}
            </div>
          ))}
        </div>
      </div>

      <div className="py-4 px-2">
        <h2 className="font-bold text-xl mb-4">Technical Skills</h2>
        <div className="flex">
          {technicalSkills.map((skill) => (
            <div
              className="py-2 mr-2 px-4 text-xs leading-3 text-white rounded-full bg-red-700 hover:bg-red-800 shadow-md cursor-pointer"
              key={skill}
            >
              {skill}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
